// Klient REST z automatycznym odświeżaniem tokenu JWT.
import { API_BASE } from '../config.js';
import { storage } from '../platform/native.js';

let access: string | null = null;

export class ApiError extends Error {
  constructor(public status: number, message: string, public data?: unknown) { super(message); }
}

async function refresh(): Promise<boolean> {
  const r = await storage.get('refresh');
  if (!r) return false;
  const res = await fetch(`${API_BASE}/api/v1/auth/refresh/`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ refresh: r }),
  });
  if (!res.ok) { await storage.remove('refresh'); return false; }
  const data = await res.json();
  access = data.access;
  if (data.refresh) await storage.set('refresh', data.refresh);
  return true;
}

export async function api<T = any>(path: string, opts: { method?: string; body?: unknown; auth?: boolean } = {}): Promise<T> {
  const doFetch = () => fetch(`${API_BASE}/api/v1${path}`, {
    method: opts.method || (opts.body ? 'POST' : 'GET'),
    headers: { 'Content-Type': 'application/json', ...(access && opts.auth !== false ? { Authorization: `Bearer ${access}` } : {}) },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  let res = await doFetch();
  if (res.status === 401 && opts.auth !== false && await refresh()) res = await doFetch();
  const data = res.headers.get('content-type')?.includes('json') ? await res.json() : null;
  if (!res.ok) {
    const msg = data?.detail || (data && typeof data === 'object' ? Object.values(data).flat().join(' ') : '') || `Błąd ${res.status}`;
    throw new ApiError(res.status, String(msg), data);
  }
  return data as T;
}

export async function login(email: string, password: string): Promise<void> {
  const data = await api<{ access: string; refresh: string }>('/auth/login/', { body: { email, password }, auth: false });
  access = data.access;
  await storage.set('refresh', data.refresh);
}

export async function register(email: string, display_name: string, password: string): Promise<void> {
  await api('/auth/register/', { body: { email, display_name, password }, auth: false });
  await login(email, password);
}

export async function restoreSession(): Promise<boolean> {
  return refresh();
}

export async function logout(): Promise<void> {
  access = null;
  await storage.remove('refresh');
}

export function accessToken(): string | null {
  return access;
}

export async function freshAccessToken(): Promise<string | null> {
  await refresh();
  return access;
}
